(function () {
  var root = document.getElementById('lmx-oyp');
  if (!root) return;

  var canvas = document.getElementById('oyp-canvas');
  var fileInput = document.getElementById('oyp-file');
  var activeSlot = 0;
  var photos = [];
  var ink = '#ffffff';
  var bw = false;
  var grid = '3x3';
  var names = {};
  var horizonReady = false;
  var FOOTER = 'BÆ, I WANT YOU TO KNOW THAT YOU ARE THE MOST BEAUTIFUL STORY THAT DESTINY WROTE IN MY LIFE, I CHOOSE YOU TODAY, TOMORROW AND FOR THE REST OF MY LIFE, I LOVE YOU MY BEAUTIFUL CHILD.';

  var TPL = [
    { id: 'clasico', name: 'Clásico LimitedMX', w: 1080, h: 1650, photos: 9, names: [
      { id: 'title', label: 'Nombre / título', value: 'ONLY YOU' },
      { id: 'corner', label: 'Nombre abajo derecha', value: 'WANNA BE YOURS' },
      { id: 'footer', label: 'Texto largo', type: 'textarea', value: FOOTER }
    ]},
    { id: 'onlyyou8', name: 'Only You · 8 fotos', w: 1080, h: 1440, photos: 8, names: [
      { id: 'title', label: 'Nombre / título', value: 'ONLY YOU' },
      { id: 'initials', label: 'Iniciales', value: 'X+X' }
    ]},
    { id: 'girlfriend9', name: 'Girlfriend · 9 fotos', w: 1080, h: 1440, photos: 9, names: [
      { id: 'title', label: 'Nombre', value: 'GIRLFRIEND' }
    ]},
    { id: 'artistas4', name: 'Only You Simple · 4 fotos', w: 1080, h: 1440, photos: 4, names: [
      { id: 'title', label: 'Nombre', value: 'ONLY YOU' }
    ]},
    { id: 'ojos', name: 'Ojos · 1 foto', w: 1080, h: 1440, photos: 1, names: [
      { id: 'title', label: 'Nombre', value: 'ONLY YOU' }
    ]},
    { id: 'corazon18', name: 'Corazón · 18 fotos', w: 1080, h: 1440, photos: 18, names: [
      { id: 'title', label: 'Nombre', value: 'ONLY YOU' }
    ]},
    { id: 'luna24', name: 'Luna · 24 fotos', w: 1080, h: 1440, photos: 24, names: [
      { id: 'title', label: 'Nombre', value: 'ONLY YOU' }
    ]},
    { id: 'polaroid', name: 'Polaroid · 1 foto', w: 1080, h: 1350, photos: 1, names: [
      { id: 'title', label: 'Nombre', value: 'NICKI' }
    ]}
  ];
  var tplId = 'clasico';

  TPL.forEach(function (t) {
    names[t.id] = {};
    t.names.forEach(function (n) { names[t.id][n.id] = n.value; });
  });

  function clasicoGrid() {
    var parts = String(grid || '3x3').split('x');
    var cols = parseInt(parts[0], 10) || 3;
    var rows = parseInt(parts[1], 10) || 3;
    return { cols: cols, rows: rows, n: cols * rows };
  }
  function tpl() {
    var t = TPL.filter(function (x) { return x.id === tplId; })[0];
    if (t.id === 'clasico') t.photos = clasicoGrid().n;
    return t;
  }
  function nm() { return names[tplId]; }
  function fontFill() { return horizonReady ? 'HorizonOY, Impact, sans-serif' : 'Impact, sans-serif'; }
  function fontOut() { return horizonReady ? 'HorizonOutOY, Impact, sans-serif' : 'Impact, sans-serif'; }

  try {
    var f1 = new FontFace('HorizonOY', 'url(https://cdn.shopify.com/s/files/1/0686/6658/9357/files/horizon.otf?v=1761377333)');
    var f2 = new FontFace('HorizonOutOY', 'url(https://cdn.shopify.com/s/files/1/0686/6658/9357/files/horizon_outlined.otf?v=1761377333)');
    Promise.all([f1.load(), f2.load()]).then(function (faces) {
      faces.forEach(function (f) { document.fonts.add(f); });
      horizonReady = true;
      draw();
    }).catch(draw);
  } catch (e) {}
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(draw);

  function fit(c, text, maxW, maxS, minS, font, weight) {
    var size = maxS;
    var w = weight || '700';
    c.font = w + ' ' + size + 'px ' + font;
    while (size > minS && c.measureText(text).width > maxW) {
      size -= 2;
      c.font = w + ' ' + size + 'px ' + font;
    }
    return size;
  }

  function wrap(c, text, maxW) {
    var words = String(text || '').split(/\s+/);
    var lines = [];
    var line = '';
    words.forEach(function (w) {
      var test = line ? line + ' ' + w : w;
      if (c.measureText(test).width > maxW && line) {
        lines.push(line);
        line = w;
      } else line = test;
    });
    if (line) lines.push(line);
    return lines;
  }

  var preview = true;

  function cover(c, img, x, y, w, h) {
    c.save();
    c.beginPath();
    c.rect(x, y, w, h);
    c.clip();
    if (!img) {
      if (preview) {
        c.fillStyle = ink;
        c.globalAlpha = 0.12;
        c.fillRect(x, y, w, h);
        c.globalAlpha = 0.55;
        c.font = '600 16px Inter, sans-serif';
        c.textAlign = 'center';
        c.textBaseline = 'middle';
        c.fillText('Foto', x + w / 2, y + h / 2);
        c.restore();
        strokeFrame(c, x, y, w, h);
      } else {
        c.restore();
      }
      return;
    }
    if (bw) c.filter = 'grayscale(1) contrast(1.08)';
    var s = Math.max(w / img.width, h / img.height);
    var dw = img.width * s;
    var dh = img.height * s;
    c.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
    c.restore();
    strokeFrame(c, x, y, w, h);
  }

  function strokeFrame(c, x, y, w, h) {
    c.save();
    c.strokeStyle = ink;
    c.lineWidth = 4;
    c.strokeRect(x + 2, y + 2, w - 4, h - 4);
    c.restore();
  }

  function stackedTitle(c, W, text, y0, maxW, maxS) {
    var t = String(text || '').toUpperCase() || ' ';
    var sz = fit(c, t, maxW, maxS, 28, fontFill(), '700');
    c.textAlign = 'center';
    c.fillStyle = ink;
    c.font = '700 ' + sz + 'px ' + fontFill();
    c.fillText(t, W / 2, y0);
    c.font = sz + 'px ' + fontOut();
    c.strokeStyle = ink;
    c.lineWidth = Math.max(2, sz * 0.02);
    c.fillText(t, W / 2, y0 + sz + 6);
    c.strokeText(t, W / 2, y0 + sz + 6);
    c.fillText(t, W / 2, y0 + (sz + 6) * 2);
    c.strokeText(t, W / 2, y0 + (sz + 6) * 2);
    return { size: sz, bottom: y0 + (sz + 6) * 2 + 28 };
  }

  function iconsRow(c, x, y, n, size, gap) {
    for (var i = 0; i < n; i++) {
      var bx = x + i * (size + gap);
      c.strokeStyle = ink;
      c.lineWidth = 2;
      if (i % 2 === 0) {
        c.beginPath();
        c.arc(bx + size / 2, y + size / 2, size / 2 - 2, 0, Math.PI * 2);
        c.stroke();
      } else {
        c.strokeRect(bx, y, size, size);
        c.beginPath();
        c.moveTo(bx + 5, y + 5);
        c.lineTo(bx + size - 5, y + size - 5);
        c.moveTo(bx + size - 5, y + 5);
        c.lineTo(bx + 5, y + size - 5);
        c.stroke();
      }
    }
  }

  function photoGrid(c, n, cols, x, y, gw, gh, gap) {
    var rows = Math.ceil(n / cols);
    var cw = (gw - gap * (cols - 1)) / cols;
    var ch = (gh - gap * (rows - 1)) / rows;
    for (var i = 0; i < n; i++) {
      var col = i % cols;
      var r = Math.floor(i / cols);
      cover(c, photos[i], x + col * (cw + gap), y + r * (ch + gap), cw, ch);
    }
  }

  function drawClasico(c, W, H) {
    c.clearRect(0, 0, W, H);
    var g = clasicoGrid();
    var title = stackedTitle(c, W, nm().title || 'ONLY YOU', 110, 960, 110);
    var gridTop = title.bottom;
    var gridW = 960;
    var gap = 10;
    var cell = (gridW - gap * (g.cols - 1)) / g.cols;
    var gridH = cell * g.rows + gap * (g.rows - 1);
    photoGrid(c, g.n, g.cols, 60, gridTop, gridW, gridH, gap);
    var fy = gridTop + gridH + 48;
    var footer = nm().footer || FOOTER;
    c.fillStyle = ink;
    c.textAlign = 'center';
    c.textBaseline = 'alphabetic';
    c.font = '700 14px Inter, Arial, sans-serif';
    var footerLines = wrap(c, footer, 980);
    footerLines.forEach(function (ln, i) {
      c.fillText(ln.toUpperCase(), W / 2, fy + i * 20);
    });
    var heartY = fy + footerLines.length * 20 + 22;
    c.fillStyle = ink;
    c.font = '700 22px sans-serif';
    c.fillText('❤', W / 2, heartY);
    c.fillStyle = ink;
    var iconY = heartY + 36;
    iconsRow(c, 60, iconY, 6, 35, 8);
    var chartX = 60;
    var chartY = iconY + 50;
    var chartW = 35 * 6 + 8 * 5;
    var chartH = 60;
    c.strokeStyle = ink;
    c.lineWidth = 2;
    c.strokeRect(chartX, chartY, chartW, chartH);
    c.setLineDash([4, 4]);
    for (var g = 1; g < 5; g++) {
      c.beginPath();
      c.moveTo(chartX, chartY + (g * chartH) / 5);
      c.lineTo(chartX + chartW, chartY + (g * chartH) / 5);
      c.stroke();
    }
    c.setLineDash([]);
    var pts = [20, 40, 25, 35, 30, 15, 45, 38, 20, 60, 55];
    c.beginPath();
    for (var p = 0; p < pts.length; p++) {
      var px = chartX + (p * chartW) / (pts.length - 1);
      var py = chartY + chartH - Math.min(Math.max(pts[p], 0), 60);
      if (p === 0) c.moveTo(px, py);
      else c.lineTo(px, py);
    }
    c.stroke();
    var corner = String(nm().corner || 'WANNA BE YOURS').replace(/\n/g, ' ').trim().toUpperCase() || ' ';
    var parts = corner.split(/\s+/);
    var lines = parts.length === 1 ? parts : [parts.slice(0, -1).join(' '), parts[parts.length - 1]];
    var iconsRight = 60 + 35 * 6 + 8 * 5;
    var maxCornerW = Math.max(80, W - 60 - iconsRight - 30);
    var sz = 36;
    c.textAlign = 'right';
    lines.forEach(function (ln) { sz = Math.min(sz, fit(c, ln, maxCornerW, 36, 12, fontFill(), '700')); });
    c.font = '700 ' + sz + 'px ' + fontFill();
    c.fillStyle = ink;
    lines.forEach(function (ln, i) {
      c.fillText(ln, W - 60, iconY + 32 + i * (sz + 10));
    });
  }

  function drawOnlyYou8(c, W, H) {
    c.clearRect(0, 0, W, H);
    var title = stackedTitle(c, W, nm().title || 'ONLY YOU', 100, 980, 100);
    var y = title.bottom;
    var gap = 10;
    var leftW = 500;
    var rightW = W - 80 - leftW - gap;
    var gh = 780;
    var i, col, r, cw, ch;
    for (i = 0; i < 4; i++) {
      col = i % 2;
      r = Math.floor(i / 2);
      cw = (leftW - gap) / 2;
      ch = (gh - gap) / 2;
      cover(c, photos[i], 40 + col * (cw + gap), y + r * (ch + gap), cw, ch);
    }
    for (i = 0; i < 4; i++) {
      col = i % 2;
      r = Math.floor(i / 2);
      cw = (rightW - gap) / 2;
      ch = (gh - gap) / 2;
      cover(c, photos[4 + i], 40 + leftW + gap + col * (cw + gap), y + r * (ch + gap), cw, ch);
    }
    iconsRow(c, 40, y + gh + 36, 6, 38, 8);
    c.fillStyle = ink;
    c.textAlign = 'left';
    c.font = '800 18px Inter, sans-serif';
    c.fillText('PERFECTGIRLFRIEND', 40, y + gh + 110);
    var ini = String(nm().initials || 'X+X').toUpperCase();
    var sz = fit(c, ini, 360, 64, 22, fontFill(), '700');
    c.font = '700 ' + sz + 'px ' + fontFill();
    c.textAlign = 'right';
    c.fillText(ini, W - 40, y + gh + 110);
  }

  function drawGirlfriend9(c, W, H) {
    c.clearRect(0, 0, W, H);
    var title = stackedTitle(c, W, nm().title || 'GIRLFRIEND', 100, 980, 96);
    photoGrid(c, 9, 3, 40, title.bottom, 1000, 1000, 8);
  }

  function drawArtistas4(c, W, H) {
    c.clearRect(0, 0, W, H);
    var title = String(nm().title || 'NICKI').toUpperCase();
    var sz = fit(c, title, 1000, 140, 40, fontFill(), '900');
    c.fillStyle = ink;
    c.textAlign = 'center';
    c.textBaseline = 'alphabetic';
    c.font = '900 ' + sz + 'px ' + fontFill();
    c.fillText(title, W / 2, 70 + sz);
    photoGrid(c, 4, 2, 50, 90 + sz + 24, 980, 1100, 12);
  }

  function drawOjos(c, W, H) {
    c.clearRect(0, 0, W, H);
    var title = String(nm().title || 'ONLY YOU').toUpperCase();
    var sz = fit(c, title, 1000, 110, 32, fontFill(), '700');
    c.fillStyle = ink;
    c.textAlign = 'center';
    c.font = '700 ' + sz + 'px ' + fontFill();
    c.fillText(title, W / 2, 90 + sz * 0.3);
    cover(c, photos[0], 80, 160, 920, 1120);
  }

  var HEART = [
    [0, 0], [1, 0], [3, 0], [4, 0],
    [0, 1], [1, 1], [2, 1], [3, 1], [4, 1],
    [0, 2], [1, 2], [2, 2], [3, 2], [4, 2],
    [1, 3], [2, 3], [3, 3],
    [2, 4]
  ];

  function drawCorazon(c, W, H) {
    c.clearRect(0, 0, W, H);
    var title = String(nm().title || 'ONLY YOU').toUpperCase();
    var sz = fit(c, title, 980, 72, 24, fontFill(), '700');
    c.fillStyle = ink;
    c.textAlign = 'center';
    c.font = '700 ' + sz + 'px ' + fontFill();
    c.fillText(title, W / 2, 70 + sz * 0.2);
    var cols = 5;
    var rows = 5;
    var gap = 8;
    var gw = 900;
    var gh = 1180;
    var cw = (gw - gap * (cols - 1)) / cols;
    var ch = (gh - gap * (rows - 1)) / rows;
    var ox = (W - gw) / 2;
    var oy = 110;
    HEART.forEach(function (cell, i) {
      cover(c, photos[i], ox + cell[0] * (cw + gap), oy + cell[1] * (ch + gap), cw, ch);
    });
  }

  function drawLuna(c, W, H) {
    c.clearRect(0, 0, W, H);
    var title = String(nm().title || 'ONLY YOU').toUpperCase();
    var cx = W / 2;
    var cy = H / 2 + 20;
    var n = 24;
    for (var i = 0; i < n; i++) {
      var a = -Math.PI * 0.72 + (i / (n - 1)) * Math.PI * 1.44;
      var ring = i % 2;
      var r = 280 + ring * 110;
      var size = ring ? 78 : 96;
      var x = cx + Math.cos(a) * r - size / 2;
      var y = cy + Math.sin(a) * r - size / 2;
      cover(c, photos[i], x, y, size, size);
    }
    var sz = fit(c, title, 320, 48, 16, fontFill(), '700');
    c.fillStyle = ink;
    c.textAlign = 'center';
    c.textBaseline = 'middle';
    c.font = '700 ' + sz + 'px ' + fontFill();
    c.fillText(title, cx, cy);
  }

  function drawPolaroid(c, W, H) {
    c.clearRect(0, 0, W, H);
    c.save();
    c.strokeStyle = ink;
    c.lineWidth = 6;
    c.strokeRect(90, 80, 900, 1180);
    c.restore();
    cover(c, photos[0], 130, 120, 820, 920);
    var title = String(nm().title || 'NICKI');
    var sz = fit(c, title, 800, 64, 22, 'Caveat, cursive', '700');
    c.fillStyle = ink;
    c.textAlign = 'center';
    c.textBaseline = 'alphabetic';
    c.font = '700 ' + sz + 'px Caveat, cursive';
    c.fillText(title, W / 2, 1180);
  }

  function paint(c, t) {
    c.textBaseline = 'alphabetic';
    if (t.id === 'clasico') drawClasico(c, t.w, t.h);
    else if (t.id === 'onlyyou8') drawOnlyYou8(c, t.w, t.h);
    else if (t.id === 'girlfriend9') drawGirlfriend9(c, t.w, t.h);
    else if (t.id === 'artistas4') drawArtistas4(c, t.w, t.h);
    else if (t.id === 'ojos') drawOjos(c, t.w, t.h);
    else if (t.id === 'corazon18') drawCorazon(c, t.w, t.h);
    else if (t.id === 'luna24') drawLuna(c, t.w, t.h);
    else if (t.id === 'polaroid') drawPolaroid(c, t.w, t.h);
  }

  function draw() {
    var t = tpl();
    canvas.width = t.w;
    canvas.height = t.h;
    canvas.style.background = ink === '#ffffff' ? '#111' : '#f3f3f3';
    paint(canvas.getContext('2d'), t);
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  function renderFields() {
    var t = tpl();
    var box = document.getElementById('oyp-fields');
    box.innerHTML = t.names.map(function (f) {
      if (f.type === 'textarea') {
        return '<label for="oyp-n-' + f.id + '">' + f.label + '</label><textarea id="oyp-n-' + f.id + '" rows="4">' + esc(nm()[f.id] || '') + '</textarea>';
      }
      return '<label for="oyp-n-' + f.id + '">' + f.label + '</label><input type="text" id="oyp-n-' + f.id + '" value="' + esc(nm()[f.id] || '') + '" autocomplete="off">';
    }).join('');
    t.names.forEach(function (f) {
      document.getElementById('oyp-n-' + f.id).addEventListener('input', function (e) {
        nm()[f.id] = e.target.value;
        draw();
      });
    });
    var gridWrap = document.getElementById('oyp-grid-wrap');
    if (gridWrap) gridWrap.hidden = t.id !== 'clasico';
    renderSlots();
  }

  function renderSlots() {
    var n = tpl().photos;
    var box = document.getElementById('oyp-slots');
    var html = '';
    for (var i = 0; i < n; i++) {
      html += '<div class="lmx-oy__slot' + (i === activeSlot ? ' is-on' : '') + '" data-i="' + i + '">';
      if (photos[i]) html += '<img alt="" src="' + photos[i].src + '">';
      else html += '<span>Foto ' + (i + 1) + '</span>';
      html += '</div>';
    }
    box.innerHTML = html;
    box.querySelectorAll('.lmx-oy__slot').forEach(function (el) {
      el.addEventListener('click', function () {
        activeSlot = parseInt(el.getAttribute('data-i'), 10);
        renderSlots();
        fileInput.click();
      });
    });
  }

  document.getElementById('oyp-templates').innerHTML = TPL.map(function (t) {
    return '<button type="button" class="lmx-oy__tpl" data-id="' + t.id + '">' + t.name + '</button>';
  }).join('');
  document.getElementById('oyp-templates').addEventListener('click', function (e) {
    var b = e.target.closest('[data-id]');
    if (!b) return;
    tplId = b.getAttribute('data-id');
    activeSlot = 0;
    document.querySelectorAll('#oyp-templates .lmx-oy__tpl').forEach(function (x) {
      x.classList.toggle('is-on', x.getAttribute('data-id') === tplId);
    });
    renderFields();
    draw();
  });
  document.querySelector('#oyp-templates .lmx-oy__tpl').classList.add('is-on');

  function setInk(v) {
    ink = v;
    document.getElementById('oyp-ink-w').classList.toggle('is-on', v === '#ffffff');
    document.getElementById('oyp-ink-k').classList.toggle('is-on', v === '#000000');
    draw();
  }
  document.getElementById('oyp-ink-w').addEventListener('click', function () { setInk('#ffffff'); });
  document.getElementById('oyp-ink-k').addEventListener('click', function () { setInk('#000000'); });
  document.getElementById('oyp-bw').addEventListener('change', function (e) {
    bw = e.target.checked;
    draw();
  });
  document.getElementById('oyp-grid').addEventListener('change', function (e) {
    grid = e.target.value;
    activeSlot = Math.min(activeSlot, Math.max(0, clasicoGrid().n - 1));
    renderSlots();
    draw();
  });

  function loadFile(f, slot) {
    if (!f || !f.type || f.type.indexOf('image') !== 0) return;
    if (slot < 0 || slot >= tpl().photos) return;
    var img = new Image();
    img.onload = function () {
      photos[slot] = img;
      renderSlots();
      draw();
    };
    img.src = URL.createObjectURL(f);
  }
  fileInput.addEventListener('change', function () {
    var files = fileInput.files;
    if (!files) return;
    for (var i = 0; i < files.length; i++) loadFile(files[i], activeSlot + i);
    if (files.length) activeSlot = Math.min(tpl().photos - 1, activeSlot + files.length);
    fileInput.value = '';
  });
  root.addEventListener('dragover', function (e) { e.preventDefault(); });
  root.addEventListener('drop', function (e) {
    e.preventDefault();
    var files = e.dataTransfer && e.dataTransfer.files;
    if (!files) return;
    for (var i = 0; i < files.length; i++) loadFile(files[i], activeSlot + i);
  });
  document.addEventListener('paste', function (e) {
    if (!root.offsetParent) return;
    var items = e.clipboardData && e.clipboardData.items;
    if (!items) return;
    for (var i = 0; i < items.length; i++) {
      if (items[i].type.indexOf('image') === 0) {
        loadFile(items[i].getAsFile(), activeSlot);
        break;
      }
    }
  });

  function crc32(buf) {
    var table = crc32.t;
    if (!table) {
      table = crc32.t = new Uint32Array(256);
      for (var n = 0; n < 256; n++) {
        var c = n;
        for (var k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
        table[n] = c;
      }
    }
    var crc = 0xffffffff;
    for (var i = 0; i < buf.length; i++) crc = table[(crc ^ buf[i]) & 255] ^ (crc >>> 8);
    return (crc ^ 0xffffffff) >>> 0;
  }
  function setDpi(dataUrl, dpi) {
    var raw = atob(dataUrl.split(',')[1]);
    var bytes = new Uint8Array(raw.length);
    for (var i = 0; i < raw.length; i++) bytes[i] = raw.charCodeAt(i);
    var ppm = Math.round(dpi / 0.0254);
    var chunk = new Uint8Array(21);
    var dv = new DataView(chunk.buffer);
    dv.setUint32(0, 9);
    chunk[4] = 112; chunk[5] = 72; chunk[6] = 89; chunk[7] = 115;
    dv.setUint32(8, ppm);
    dv.setUint32(12, ppm);
    chunk[16] = 1;
    dv.setUint32(17, crc32(chunk.subarray(4, 17)));
    var out = new Uint8Array(bytes.length + chunk.length);
    out.set(bytes.subarray(0, 33), 0);
    out.set(chunk, 33);
    out.set(bytes.subarray(33), 33 + chunk.length);
    var bin = '';
    for (i = 0; i < out.length; i++) bin += String.fromCharCode(out[i]);
    return 'data:image/png;base64,' + btoa(bin);
  }

  document.getElementById('oyp-download').addEventListener('click', function () {
    var scale = 3;
    var t = tpl();
    var off = document.createElement('canvas');
    off.width = t.w * scale;
    off.height = t.h * scale;
    var oc = off.getContext('2d', { alpha: true });
    oc.clearRect(0, 0, off.width, off.height);
    oc.scale(scale, scale);
    preview = false;
    paint(oc, t);
    preview = true;
    var a = document.createElement('a');
    a.href = setDpi(off.toDataURL('image/png'), 300);
    a.download = 'only-you-' + t.id + '.png';
    a.click();
  });

  setInk('#ffffff');
  renderFields();
  draw();
})();
